import { render, staticRenderFns } from "./RecurringRemarkDetail.vue?vue&type=template&id=ef82b4e2&scoped=true"
import script from "./RecurringRemarkDetail.vue?vue&type=script&lang=js"
export * from "./RecurringRemarkDetail.vue?vue&type=script&lang=js"
import style0 from "./RecurringRemarkDetail.vue?vue&type=style&index=0&id=ef82b4e2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef82b4e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef82b4e2')) {
      api.createRecord('ef82b4e2', component.options)
    } else {
      api.reload('ef82b4e2', component.options)
    }
    module.hot.accept("./RecurringRemarkDetail.vue?vue&type=template&id=ef82b4e2&scoped=true", function () {
      api.rerender('ef82b4e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/recurringremarks/RecurringRemarkDetail.vue"
export default component.exports